function Key() {
  return (
    <svg viewBox="0 0 48 48" aria-hidden="true">
      <circle cx="31" cy="17" r="9" />
      <path d="M25 23L8 40l-3-3 17-17" />
      <path d="M10 38l5 5" />
      <circle cx="31" cy="17" r="2" />
    </svg>
  );
}

export default Key;
